import { useState } from "react";

export default function Hero() {
  const [kw, setKw] = useState("");
  const hotWords = ["名场面", "颁奖礼救场", "剧组杀青", "竞演名场面"];

  const onSearch = (e: React.FormEvent) => {
    e.preventDefault();
    document.getElementById("archive")?.scrollIntoView({ behavior: "smooth" });
  };

  const jumpWith = (w: string) => {
    setKw(w);
    document.getElementById("archive")?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section id="top" className="relative overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=cinematic%20editorial%20collage%20of%20backstage%20spotlight%20curtains%2C%20red%20carpet%20glow%2C%20variety%20show%20arena%20lights%20and%20film%20set%20equipment%2C%20warm%20coral%20red%20and%20cream%20palette%2C%20soft%20artistic%20blur%2C%20no%20recognizable%20faces%2C%20moody%20magazine%20cover%20background&width=1600&height=900&seq=hero-cover&orientation=landscape"
          alt="国产吃瓜娱乐名场面编辑部背景图"
          className="h-full w-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-primary-950/70 via-primary-900/55 to-background-50"></div>
      </div>

      <div className="relative mx-auto flex min-h-[560px] w-full max-w-7xl flex-col justify-center px-4 pb-16 pt-28 md:min-h-[640px] md:px-6 md:pt-32">
        <span className="mb-5 inline-flex w-fit items-center gap-2 rounded-full bg-accent-500 px-4 py-1.5 text-xs font-bold tracking-wider text-background-50 whitespace-nowrap">
          <i className="ri-sparkling-2-fill" aria-hidden="true"></i>
          圈子图鉴 · 持续收录
        </span>

        <h1 className="max-w-3xl font-heading text-4xl font-black leading-tight text-background-50 md:text-6xl">
          名场面不散场，
          <br />
          这一口 <span className="text-accent-300">吃透每一层</span>
        </h1>
        <p className="mt-6 max-w-2xl text-base leading-relaxed text-background-100 md:text-lg">
          从台前红毯到幕后片场，从热播综艺到网红直播间——国产吃瓜整理明星、网红、综艺与剧组的高能瞬间与圈子生态，陪你理性又尽兴地吃瓜。
        </p>

        <form onSubmit={onSearch} className="mt-9 w-full max-w-xl">
          <div className="flex flex-col gap-2 rounded-2xl bg-background-50/95 p-2 sm:flex-row sm:items-center sm:rounded-full">
            <div className="flex items-center gap-2 px-3 py-1">
              <i className="ri-search-line text-foreground-500" aria-hidden="true"></i>
              <input
                value={kw}
                onChange={(e) => setKw(e.target.value)}
                type="text"
                aria-label="搜索名场面"
                placeholder="想找哪一口瓜？例如「颁奖礼救场」"
                className="w-full bg-transparent text-sm text-foreground-900 outline-none placeholder:text-foreground-400"
              />
            </div>
            <button
              type="submit"
              className="whitespace-nowrap rounded-xl bg-primary-500 px-6 py-2.5 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600 sm:rounded-full"
            >
              开吃
            </button>
          </div>
        </form>

        <div className="mt-5 flex flex-wrap items-center gap-2">
          <span className="text-xs text-background-200">大家都在搜：</span>
          {hotWords.map((w) => (
            <button
              key={w}
              type="button"
              onClick={() => jumpWith(w)}
              className="whitespace-nowrap rounded-full border border-background-200/60 bg-background-50/10 px-3 py-1 text-xs text-background-100 transition-colors hover:bg-accent-500 hover:text-background-50"
            >
              #{w}
            </button>
          ))}
        </div>
      </div>
    </section>
  );
}